module.exports = __webpack_public_path__ + "assets/img/triangle3.2f073e6c.svg";